import { Component } from '@angular/core';

@Component({
  selector: 'app-slider-biens',
  templateUrl: './slider-biens.component.html',
  styleUrls: ['./slider-biens.component.scss']
})
export class SliderBiensComponent {

}
